// airdatepicker.js
import AirDatepicker from 'air-datepicker'
import localeUk from 'air-datepicker/locale/uk'
import localeEn from 'air-datepicker/locale/en'
import 'air-datepicker/air-datepicker.css'

const pickers = document.querySelectorAll('.js-air-datepicker')
const multipleDatesSeparator = ' - '

Array.from(pickers).forEach(picker => {
    const range = picker.dataset.range == 'true'
    new AirDatepicker(picker, {
        locale: localeEn,
        position: picker.dataset.position,
        range,
        multipleDatesSeparator,
        timepicker: true,
        firstDay: 1,
        timeFormat: 'HH:mm'
    })
})

document.querySelectorAll('.js-datepicker-hide-on-scroll-listener').forEach(listener => {
    let scrollTimer = null
    listener.addEventListener('scroll', () => {
        clearTimeout(scrollTimer)
        scrollTimer = setTimeout(() => {
            pickersArray.forEach(p => {
                try {
                    p.hide()
                } catch (e) {}
            })
        }, 100)
    })
})
